import { PaletteOptions } from "@mui/material"

const palette: PaletteOptions = {
  primary: {
    main: "#89BD23",
    light: "#E8F2D2",
  },
  secondary: {
    main: "#FF8C42",
    light: "#FFD1A3",
    dark: "#CC6E30",
  },
  warning: {
    main: "#FFA726",
  },
  success: {
    main: "#4ECC71",
  },
  error: {
    main: "#EB001B",
  },
  grey: {
    "100": "#FDFDFD",
    "200": "#F9F9F9",
    "300": "#F0F0F0",
    "400": "#E5E5E5",
    "500": "#A2A2A2",
    "600": "#757575",
  },
}

export default palette
